import { TaxCode } from "../../constant/TaxCode";

export enum WfsResponseType {
  Data = 1,
  DeferredRequest = 2,
  PaymentRequired = 3,
  BadRequest = 4,
  DuplicateOrder = 5,
}

export interface WfsResponse {
  type: WfsResponseType;
}

export interface WfsDataResponse extends WfsResponse {
  data: Blob;
  fileName: string;
}

export interface WfsDeferredRequestResponse extends WfsResponse {
  deferredRequestId: string;
}

export interface WfsDuplicateOrderResponse extends WfsResponse {
  orderId: string;
  orderItemId: string;
  isInBasket: boolean;
}

export interface WfsPaymentRequiredResponse extends WfsResponse {
  id: string;
  description: string;
  layerName: string;
  priceExTax: number;
  priceIncTax: number;
  transactionCurrencyCode: string;
  taxCode: TaxCode;
  isPremium: boolean;
  parameters: any;
}

export interface WfsBadRequestResponse extends WfsResponse {
  error: string;
}
